export class SignedPrintAuthorization {
    public Id: string;
    public CreatedByEmployeeId: string;
    public CreatedDatetime: string;
    public AttachmentId: string;
    public PrescriptionId: string;
    public ConsultationRequestId: string;
    public RequestId: string;
    public PatientFormId: string;
    public OneTimeOnly: boolean;
    public IsConsumed: boolean;
    public EncounterId?: string;

    public static isSignedBy(signedPrintAuthorization: SignedPrintAuthorization, contactFacetId: string): boolean {
        return signedPrintAuthorization?.CreatedByEmployeeId === contactFacetId;
    }

    public static getLast(signedPrintAuthorizations: SignedPrintAuthorization[], encounterId?: string): SignedPrintAuthorization {
        return signedPrintAuthorizations
            ?.filter(p => !encounterId || p.EncounterId === encounterId)
            ?.sortByPropertyDesc(p => p.CreatedDatetime)
            ?.firstOrDefault();
    }

    public static isLastSignatureFrom(signedPrintAuthorizations: SignedPrintAuthorization[], contactFacetId: string, encounterId?: string): boolean {
        const lastSignedPrintAuthorization = SignedPrintAuthorization.getLast(signedPrintAuthorizations, encounterId);
        return SignedPrintAuthorization.isSignedBy(lastSignedPrintAuthorization, contactFacetId);
    }
}
